import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody, TextTitle } from '@tkww/orion-web-ds-text';
import React from 'react';
import type {
	EstimateSourceType,
	PricingEstimationService,
} from '../../../../types';
import type { EstimateServiceBreakdownItem } from '../../../utils/estimateDisplay';
import { EstimateDisclaimer } from '../../EstimateDisclaimer';
import { GuestCountField } from '../GuestCountField';
import { ServicesList } from '../ServicesList';
import { WeddingDateField } from '../WeddingDateField';
import Styles from './styles.scss';

interface EditEstimateContentProps {
	closeButtonRef: React.RefObject<HTMLButtonElement>;
	onClose: () => void;
	previewPrice: string | null;
	selectedServices: PricingEstimationService[];
	onToggleService: (service: PricingEstimationService) => void;
	servicePrices: Partial<
		Record<PricingEstimationService, EstimateServiceBreakdownItem | null>
	>;
	showMinimumSpendInfo: boolean;
	guestCount: string;
	onGuestCountChange: (value: string) => void;
	weddingDate: string;
	onWeddingDateChange: (value: string) => void;
	isModalOpen: boolean;
	estimateSourceType?: EstimateSourceType;
}

export const EditEstimateContent = ({
	closeButtonRef,
	onClose,
	previewPrice,
	selectedServices,
	onToggleService,
	servicePrices,
	showMinimumSpendInfo,
	guestCount,
	onGuestCountChange,
	weddingDate,
	onWeddingDateChange,
	isModalOpen,
	estimateSourceType,
}: EditEstimateContentProps) => (
	<>
		<div className={Styles.pricingDetails}>
			<button
				type="button"
				ref={closeButtonRef}
				className={Styles.closeButton}
				onClick={onClose}
				aria-label="Close modal"
			>
				<Icon name="close" size="md" aria-label={undefined} aria-hidden />
			</button>
			<TextBody size="md" bold>
				The Knot estimate *
			</TextBody>
			{previewPrice && (
				<TextTitle size="md" key={previewPrice} className={Styles.previewPrice}>
					{previewPrice}
				</TextTitle>
			)}
		</div>
		<div className={Styles.content}>
			<EstimateDisclaimer estimateSourceType={estimateSourceType} />
			<div className={Styles.settings}>
				<div className={Styles.settingsHeading}>
					<TextBody size="xl" bold>
						Your wedding details
					</TextBody>
					<TextBody size="md">
						Change any of these details to see your estimate update in real
						time.
					</TextBody>
				</div>
				<ServicesList
					selectedServices={selectedServices}
					onToggle={onToggleService}
					servicePrices={servicePrices}
					showMinimumSpendInfo={showMinimumSpendInfo}
				/>
				<GuestCountField value={guestCount} onChange={onGuestCountChange} />
				<WeddingDateField
					key={String(isModalOpen)}
					value={weddingDate}
					onChange={onWeddingDateChange}
				/>
			</div>
		</div>
	</>
);
